/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CheckIcon } from '@heroicons/react/solid';
import convertJsonToHtml from '../../../utils/convertJsonToHtml';

function Option(props) {
  const { label, selected, index, onClick, submitted, isAnswer } = props;

  let style = 'w-full rounded-md shadow-sm';
  if (isAnswer && submitted) {
    style = `${style} bg-green text-white`;
  } else if (selected && !isAnswer && submitted) {
    style = `${style} bg-yellow text-white`;
  } else if (submitted) {
    style = `${style} bg-white`;
  } else {
    style = `${style} bg-white hover:bg-grey-light`;
  }

  return (
    <li className={style}>
      <button
        onClick={() => onClick(index)}
        type="button"
        className="flex space-x-4 w-full py-3 px-4"
        disabled={submitted}
      >
        <div className="w-5">
          {submitted ? (
            <p className="w-5" />
          ) : selected ? (
            <CheckIcon className="w-5 h-5 rounded-md border-2 border-grey-dark" />
          ) : (
            <div className="w-5 h-5 rounded-md border-2 border-grey-dark" />
          )}
        </div>
        <p className="text-left">{label}</p>
      </button>
    </li>
  );
}

Option.propTypes = {
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  submitted: PropTypes.bool.isRequired,
  isAnswer: PropTypes.bool.isRequired,
};

function Multiplechoice(props) {
  const { item } = props;
  const [selected, setSelected] = useState(
    item.content.options.map((_) => false)
  ); // Array of answer indices
  const [submitted, setSubmitted] = useState(false);

  const onClick = (clickedIndex) => {
    setSelected((old) => {
      const newAnswers = [...old];
      newAnswers[clickedIndex] = !old[clickedIndex];
      return newAnswers;
    });
  };

  const checkAnswer = () => {
    setSubmitted(true);
  };

  return (
    <main className="mt-8">
      <p>{item.content.question}</p>
      <br />
      <ul className="flex flex-col gap-y-2">
        {item.content.options.map((option, index) => (
          <Option
            key={`${index}-${item.content.answer}`}
            selected={selected[index]}
            index={index}
            onClick={onClick}
            submitted={submitted}
            isAnswer={item.content.answers.includes(index)}
            label={option}
          />
        ))}
      </ul>
      <br />
      {submitted ? (
        convertJsonToHtml(item.content.explanation)
      ) : (
        <button
          disabled={selected.length === 0}
          type="button"
          onClick={checkAnswer}
          className="bg-sky text-white rounded-md px-4 py-2 hover:bg-sky-dark float-right"
        >
          Check
        </button>
      )}
    </main>
  );
}

Multiplechoice.propTypes = {
  item: PropTypes.objectOf({
    image: PropTypes.string.isRequired,
  }).isRequired,
  currentPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
};

export default Multiplechoice;
